'use es6';

import createAction from 'flux-actions/createAction';
import { FETCHED_DOMAIN, REQUESTED_DOMAIN, RECEIVED_DOMAIN, REQUESTED_DOMAIN_FAILED } from './ActionTypes';
export const requestedDomain = createAction(REQUESTED_DOMAIN);
export const receivedDomain = createAction(RECEIVED_DOMAIN, domain => ({
  domain
}));
export const receivedDomainFailure = createAction(REQUESTED_DOMAIN_FAILED, error => ({
  error
}));
export const fetchDomain = createAction(FETCHED_DOMAIN, domainName => ({
  domainName
}));